var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoPayoutRulesAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "23px",
    viewBox: "0 0 31 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 28") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-936,-1051)",
    stroke: "#ffffff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(936,1052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21-Copy-2",
    transform: "translate(0,1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13-Copy-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.5 5.3 C 5.4 3.7 2.9 3.9 1.9 5.7 C 0.9 7.6 2.1 8.9 5.3 9.7 C 8.7 10.7 9.7 12.1 8.3 13.8 C 7 15.6 4.4 15.7 0.5 14.1",
    id: "Path-88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.6 0.4 L 5.6 19.3",
    id: "Path-89"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(11)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.4 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 -1) scale(0.95)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(0 7 10)",
    d: "M0 10 L 4 10"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(45 7 10)",
    d: "M 0 10 L 4 10"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(90 7 10)",
    d: "M 0 10 L 4 10"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(135 7 10)",
    d: "M 0 10 L 4 10"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 7 10)",
    d: "M 0 10 L 4 10"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(225 7 10)",
    d: "M 0 10 L 4 10"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(270 7 10)",
    d: "M 0 10 L 4 10"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(315 7 10)",
    d: "M 0 10 L 4 10"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 10,
    r: 4,
    strokeWidth: 3.3,
    stroke: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(7 10) scale(0.85)",
    strokeWidth: 0,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,14 C3.13400675,14 0,10.8659932 0,7 C0,3.13400675 3.13400675,0 7,0 C10.8659932,0 14,3.13400675 14,7 C14,10.8659932 10.8659932,14 7,14 Z M5.9,6 L2.7,6 L2.7,8.1328125 L5.9,8.1328125 L5.9,11.3152344 L8.0328125,11.3152344 L8.0328125,8.1328125 L11.3152344,8.1328125 L11.3152344,6 L8.0328125,6 L8.0328125,2.7 L5.9,2.7 L5.9,6 Z",
    id: "Combined-Shape"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPayoutRulesAdd);
export default __webpack_public_path__ + "static/media/ico_payout-rules-add.84b9cd02a175ae03d9c0876d7fcac872.svg";
export { ForwardRef as ReactComponent };